import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TDispatch } from '../../redux';
import { saveOfferDraft } from '../../redux/reducers';
import { selectIsNewOffer } from '../../selectors/offer';
import { SaveDraft } from './SaveDraft';

export const SaveDraftContainerBackup = () => {
  const isNewOffer = useSelector(selectIsNewOffer);

  const dispatch = useDispatch<TDispatch>();

  // TODO: сохранение в черновик нужно доделать
  const handleButtonClick = React.useCallback(() => {
    dispatch(saveOfferDraft());
  }, [dispatch]);

  if (!isNewOffer) {
    return null;
  }

  return <SaveDraft onClick={handleButtonClick} />;
};

/**
 * Флоу сохранения черновика будет доделываться в https://jira.cian.tech/browse/HA-947.
 * Пока скрываем кнопку.
 */
// istanbul ignore next
export const SaveDraftContainer = () => null;
